import { render, staticRenderFns } from "./IActionLinks.vue?vue&type=template&id=a15fe5a4&"
import script from "./IActionLinks.vue?vue&type=script&lang=js&"
export * from "./IActionLinks.vue?vue&type=script&lang=js&"
import style0 from "./IActionLinks.vue?vue&type=style&index=0&id=a15fe5a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports